import PropTypes from 'prop-types';
import { Trans, withTranslation } from 'react-i18next';

import { Button, PageError, ThemeImage } from '@ctct/ui-react';

import { useUpgradeContext } from '../UpgradeContext';
import { billingURL, helpCenterURL, billinginfoURL } from '../utils/featureUpgradeDialogURLs';

const UpgradeFailureStep = ({ t, footerContent, footerActions, closeDialog }) => {
  const [upgradeContext] = useUpgradeContext();
  const { isStripeAccount, stripePortalURL } = upgradeContext;

  if (!footerContent && !footerActions)
    // content
    return (
      <PageError
        data-qe-id="feature-upgrade-error"
        image={<ThemeImage color="pink" image="alert" size="large" data-qe-id="feature-upgrade-error-image" />}
        heading={t('upgrade-popup.error.heading')}
        description={
          <Trans i18nKey="upgrade-popup.error.body">
            <a href={billingURL} target="_blank" rel="noreferrer">
              {t('upgrade-popup.error.alt1')}
            </a>
            <a href={helpCenterURL} target="_blank" rel="noreferrer">
              {t('upgrade-popup.error.alt2')}
            </a>
          </Trans>
        }
        actions={
          <a
            href={isStripeAccount ? stripePortalURL : billinginfoURL}
            target={isStripeAccount ? undefined : '_blank'}
            rel="noreferrer"
          >
            <Button data-qe-id="feature-upgrade-error-button" text={t('upgrade-popup.error.button')} kind="primary" />
          </a>
        }
      />
    );

  // footerContent
  if (!footerActions) {
    return null;
  }

  // footerActions
  return (
    <Button
      shape="pill"
      data-qe-id="upgrade-failure-close-button"
      text={t('upgrade-popup.button-text.close')}
      kind="primary"
      onClick={closeDialog}
    />
  );
};

UpgradeFailureStep.defaultProps = {
  footerContent: false,
  footerActions: false,
};

UpgradeFailureStep.propTypes = {
  t: PropTypes.func.isRequired,
  footerContent: PropTypes.bool,
  footerActions: PropTypes.bool,
  closeDialog: PropTypes.func.isRequired,
};

export default withTranslation()(UpgradeFailureStep);
